module.exports = "../../static/fonts/Lato-Regular.7f690e5.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Lato-Regular.ttf
// module id = 912
// module chunks = 2